import { render, staticRenderFns } from "./PersonImport.vue?vue&type=template&id=7c607452&"
import script from "./PersonImport.vue?vue&type=script&setup=true&lang=js&"
export * from "./PersonImport.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PersonImport.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports